export default {
    getAccountProperties: function( accountProperties ) {
        "use strict";
        let accountProperty = {};
        _( accountProperties ).forEach(function( item ) {
            switch ( item.name ) {
                case "hos.carrier":
                    accountProperty.carrier = item;
                    break;

                case "hos.carrier.dotnumber":
                    accountProperty.carrierDotNumber = item;
                    break;

                case "hos.mainoffice.street":
                    accountProperty.mainOfficeStreet = item;
                    break;

                case "hos.mainoffice.city":
                    accountProperty.mainOfficeCity = item;
                    break;

                case "hos.mainoffice.state":
                    accountProperty.mainOfficeState = item;
                    break;

                case "hos.mainoffice.zip":
                    accountProperty.mainOfficeZip = item;
                    break;

                case "hos.mainoffice.phone":
                    accountProperty.mainOfficePhone = item;
                    break;

                case "hos.mainoffice.timezone":
                    accountProperty.mainOfficeTimezone = item;
                    break;

                case "hos.mainoffice.starttimeofday":
                    accountProperty.mainOfficeStartTimeOfDay = item;
                    break;
            }
        });

        accountProperty.mainOfficeAddress = [
            (accountProperty.mainOfficeStreet && accountProperty.mainOfficeStreet.value ? accountProperty.mainOfficeStreet.value + " " : ""),
            (accountProperty.mainOfficeCity && accountProperty.mainOfficeCity.value ? accountProperty.mainOfficeCity.value + " " : ""),
            (accountProperty.mainOfficeState && accountProperty.mainOfficeState.value ? accountProperty.mainOfficeState.value + " " : ""),
            (accountProperty.mainOfficeZip && accountProperty.mainOfficeZip.value ? accountProperty.mainOfficeZip.value : "")
        ].join( "" ).trim();

        return accountProperty;
    }
};

/**
 * Returns a certain account property from the collection of account properties
 * based on the provided account property name.
 * @param {array} accountProperties Collection of account properties
 * @returns {object} Account property data.
 */
export function accountPropertyNameFinder(accountProperties = []) {
    return function(accountPropertyName) {
        return accountProperties.find((accountProp) => {
            if (accountProp && !!accountProp.name) {
                return accountProp.name === accountPropertyName;
            }
        });
    }
}
